export class SafetyCorrectiveAction {
    id!: string
    indexId!: number
    nearMissDescription?: string | null
    anyoneInjured = false
    damageDone?: string | null
    correctionMade?: string | null
    createdOn?: Date | string | null
    createdByUserId?: string | null
    archived!: boolean
    imageUrls: string[] = []
    imageFileNames: string[] = []

    createdByName?: string | null

    static createNew(): SafetyCorrectiveAction {
        const item = new SafetyCorrectiveAction()
        item.id = crypto.randomUUID()
        return item
    }
}
